import styles from "./ReadOnlyParameterPanel.module.scss";

function ReadOnlyParameterPanel() {
  return <div className={styles["panel-parameter--empty"]} />;
}

export default ReadOnlyParameterPanel;
